export const BOGOTA_TZ = 'America/Bogota';

// Safely parse a date-only (YYYY-MM-DD) string as a Date anchored at 00:00 in America/Bogota
export function parseDateOnlyBogota(dateOnly: string): Date {
  // If input already includes time/offset, trust it; otherwise anchor to Bogota midnight
  const hasTime = /T\d{2}:\d{2}/.test(dateOnly) || /Z|[+-]\d{2}:?\d{2}$/.test(dateOnly);
  const iso = hasTime ? dateOnly : `${dateOnly}T00:00:00-05:00`;
  return new Date(iso);
}

// Format Month and Year in locale with Bogota timezone, removing Spanish "de" if present
export function formatMonthYearBogota(dateOnly: string, locale = 'es-ES'): string {
  const d = parseDateOnlyBogota(dateOnly);
  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    timeZone: BOGOTA_TZ,
  });
  const out = formatter.format(d);
  // Normalize Spanish output removing connecting word 'de' (e.g., 'octubre de 2024' -> 'octubre 2024')
  return out.replace(/\s+de\s+/gi, ' ');
}

// Extract numeric day-of-month in Bogota TZ
export function getDayOfMonthBogota(dateOnly: string): number {
  const d = parseDateOnlyBogota(dateOnly);
  const parts = new Intl.DateTimeFormat('es-ES', {
    day: 'numeric',
    timeZone: BOGOTA_TZ,
  }).formatToParts(d);
  const day = parts.find((p) => p.type === 'day')?.value;
  return Number(day);
}

// Determine if given date-only (YYYY-MM-DD) equals today in Bogota TZ
export function isTodayBogota(dateOnly: string): boolean {
  const target = parseDateOnlyBogota(dateOnly);
  const fmt = new Intl.DateTimeFormat('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: BOGOTA_TZ,
  });
  const now = new Date();
  const [t, n] = [fmt.format(target), fmt.format(now)];
  return t === n;
}
